module.exports = __webpack_public_path__ + "img/bb-logo-vert.fb2b0f7d.svg";